// extracted by mini-css-extract-plugin
export default {"contactTitle":"contact_contactTitle__wMfre","contactAddress":"contact_contactAddress__0oAH4","contactPhone":"contact_contactPhone__M4i1N"};